import { render } from "./farmTable.vue?vue&type=template&id=383a08ac&scoped=true"
import script from "./farmTable.vue?vue&type=script&lang=js"
export * from "./farmTable.vue?vue&type=script&lang=js"

import "./farmTable.vue?vue&type=style&index=0&id=383a08ac&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383a08ac"]])

export default __exports__